import React from 'react';
import { Link as GatsbyLink } from 'gatsby';

interface VLinkProps {
  to: string | null;
  activeClassName?: string;
  partiallyActive?: boolean;
  className?: string;
  newWindow?: boolean;
  noFollow?: boolean;
}

export const VLink: React.FC<VLinkProps> = ({ children, to, activeClassName, partiallyActive, newWindow, noFollow, ...other }) => {
  // Tailor the following test to your environment.
  // This example assumes that any internal link (intended for Gatsby)
  // will start with exactly one slash, and that anything else is external.
  const internal = to && /^\/(?!\/)/.test(to);
  // Use Gatsby Link for internal links, and <a> for others
  if (internal) {
    return (
      <GatsbyLink
        to={to}
        activeClassName={activeClassName}
        partiallyActive={partiallyActive}
        target={newWindow ? '_blank' : undefined}
        rel={noFollow ? 'nofollow noopener noreferer' : undefined}
        {...other}
      >
        {children}
      </GatsbyLink>
    );
  }
  if (to === null) {
    return (
      <p className="ml-8 text-xl font-bold cursor-pointer lg:text-lg lg:uppercase lg:font-normal">
        {children}
      </p>
    );
  }
  return (
    <a
      href={to}
      target={newWindow ? '_blank' : undefined}
      rel={noFollow ? 'nofollow noopener noreferer' : undefined}
      {...other}
    >
      {children}
    </a>
  );
};
